import './App.css';
import React from 'react';
import { Navigate, BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import SplashScreen from './components/splashscreen/splashscreen';
import Login from './components/loginpage/login';
import 'bootstrap/dist/css/bootstrap.min.css';
import Principal from './components/principalpage/principal';
import Sidebar from './components/sidebarpage/sidebar';
import Home from './pages/home/home';
import Detalle from './pages/detalle/detalle';
import Consulta from './pages/consulta/consulta';
import Cargar from './pages/cargar/cargar';
import CargarConsulta from './pages/cargarconsulta/cargarconsulta';
import Fusion from './pages/fusion/fusion';
import Fusion2 from './pages/fusion2/fusion2';
import CargarFusion from './pages/cargarfusion/cargarfusion';
import Reportes from './pages/reportes/reportes';
import Configuracion from './pages/configuracion/configuracion';
import RutaProtegida from './components/RutaProtegida';

function App() {
  return (
    
      <Routes>
        
        <Route path="/splashscreen" element={<SplashScreen />} />
        <Route path="/signin" element={<Login />} />
        <Route path="/*" element={<RutaProtegida><Principal /></RutaProtegida>}>
          <Route path="home" element={<Home />} />
          <Route path="reportes" element={<Reportes />} />
          <Route path="consulta" element={<Consulta />} />
          <Route path="cargar" element={<Cargar />} />
          <Route path="cargar-consulta" element={<CargarConsulta />} />
          <Route path="fusion" element={<Fusion />} />
          <Route path="fusion2" element={<Fusion2 />} />
          <Route path="cargar-fusion" element={<CargarFusion />} />
          <Route path="detalle" element={<Detalle />} />
          <Route path="configuracion" element={<Configuracion />} />
        </Route>
        <Route path="/sidebar" element={<Sidebar />} />
        <Route path="" element={<Navigate to="/splashscreen" />} /> 
      </Routes>
    
  );
}

export default function AppWithRouter() {
  return (
    <Router basename="/">
      <App />
    </Router>
  );
}